import React, { useState } from "react";
import { Typography, Box, Tabs, Tab } from "@mui/material";
import { Assignment, ReceiptLong, Assessment, AccountBalanceWallet } from "@mui/icons-material";

import EmployeeITDeclarations from "./employeeITDeclarations";
import EmployeePayslips from "./employeePayslips";
import EmployeeTaxSummary from "./employeeTaxSummary";
import EmployeeReimbursements from "./employeeReimbursements";

function MyPayroll() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box sx={{ p: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b' }}>
                My Payroll
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mb: 2 }}>
                Manage your tax declarations, view payslips, and track tax summaries
            </Typography>

            <Box sx={{
                bgcolor: '#fff',
                borderBottom: '1px solid #e2e8f0',
                borderRadius: '12px',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                p: 0.5
            }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            minWidth: 140,
                            fontWeight: 600,
                            color: '#64748b',
                            minHeight: '48px',
                            borderRadius: '8px',
                            marginRight: '8px',
                            transition: '0.3s',
                            gap: 1,
                            '&.Mui-selected': {
                                color: '#1976d2',
                                bgcolor: '#e3f2fd',
                            },
                            '&:hover': {
                                bgcolor: '#f8fafc',
                            }
                        }
                    }}
                >
                    <Tab icon={<Assignment sx={{ fontSize: 20 }} />} iconPosition="start" label="IT Declarations" />
                    <Tab icon={<ReceiptLong sx={{ fontSize: 20 }} />} iconPosition="start" label="Payslips" />
                    <Tab icon={<Assessment sx={{ fontSize: 20 }} />} iconPosition="start" label="Tax Summary" />
                    <Tab icon={<AccountBalanceWallet sx={{ fontSize: 20 }} />} iconPosition="start" label="Reimbursements" />
                </Tabs>
            </Box>

            <Box sx={{ mt: 3 }}>
                {activeTab === 0 && <EmployeeITDeclarations />}
                {activeTab === 1 && <EmployeePayslips />}
                {activeTab === 2 && <EmployeeTaxSummary />}
                {activeTab === 3 && <EmployeeReimbursements />}
            </Box>
        </Box>
    );
}

export default MyPayroll;